import PixelIcon from "./PixelIcon"

// A block of About copy paired with pixel art. Panels alternate sides down the
// section (`flip` puts the art on the left), and the art sits in a framed tile
// that drifts on its own and lifts toward the viewer on hover.
//
// The float lives on the outer .about-art and the hover lift on the inner
// .about-art-frame -- both animate `transform`, so they need separate elements
// or the hover would fight the keyframes.
//
// The art brings its own colors (see PALETTES in PixelIcon); `color` is the
// panel's accent, which tints the frame's border and both of its glows so the
// tile reads as belonging to the art it holds.
export default function AboutPanel({ art, color, flip = false, delay = 0, children }) {
    return (
        <div className = {`about-panel ${flip ? "about-panel--flip" : ""}`}>

            <div className = "about-copy text-3xl">
                {children}
            </div>

            <div className = "about-art" style = {{ animationDelay: `${delay}s` }}>
                <div className = "about-art-frame" style = {{ color }}>
                    <PixelIcon name = {art} className = "about-art-svg" />
                </div>
            </div>

        </div>
    )
}
